module.exports = __webpack_public_path__ + "img/quality.f2029ae7.svg";